import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

export const materialModules: any[] = [MatFormFieldModule, MatInputModule, MatIconModule, MatSelectModule, MatButtonModule];
